import src from "IMAGE";
export default { src, width: 1327, height: 400, blurWidth: 0, blurHeight: 0};
